import { getStructuredData } from './structuredData/structuredData'
import { getBreadcrumbList } from './breadcrumb/breadcrumbList'
import { generateSocialMetaTags } from './socialMediaTags/socialMediaTags'

export default {
  getStructuredData,
  getBreadcrumbList,
  generateSocialMetaTags
}
